// extracted by mini-css-extract-plugin
export default {"container":"_1xL0qT6DK8HLU-dXaMVLLk"};